import { API_URL, HTTP_METHODS } from '../../helpers/constants';
import request from '../../utils/request';
import { DeleteFilePayload, UploadSearchHeaderImagePayload } from './types';

export const uploadSearchHeaderImage = async (
  payload: UploadSearchHeaderImagePayload,
  authorizationToken: string,
  signal?: AbortSignal,
): Promise<{ url: string }> => {
  const formData = new FormData();
  formData.append('image', payload.image);
  formData.append('context', payload.context);
  formData.append('metadata', payload.metadata);

  return request(`${API_URL}/files/upload/image`, {
    body: formData,
    signal,
    method: HTTP_METHODS.POST,
    headers: {
      authorization: `Bearer ${authorizationToken}`,
    },
  });
};

export const deleteFile = async (
  payload: DeleteFilePayload,
  authorizationToken: string,
  signal?: AbortSignal,
): Promise<void> => {
  const { context, metadata } = payload;

  return request(`${API_URL}/files/${context}/${metadata}`, {
    signal,
    method: HTTP_METHODS.DELETE,
    headers: {
      authorization: `Bearer ${authorizationToken}`,
    },
  });
};
